import { Contact2 } from "./contact-2";

export function ContactInfoSection() {
  return <Contact2 />;
}

